import {
    FETCH_GRAPH_PRACTICE_INCOME_REQUEST,
    FETCH_GRAPH_PRACTICE_INCOME_SUCCESS,
    FETCH_GRAPH_PRACTICE_INCOME_FAILURE,
  } from "./FetchGraphPracticeIncomeTypes";
  
  const initialState = {
    loading: false,
    graphDataPracticeIncome: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GRAPH_PRACTICE_INCOME_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_GRAPH_PRACTICE_INCOME_SUCCESS:
        return {
          loading: false,
          graphDataPracticeIncome: action.payload,
          error: "",
        };
      case FETCH_GRAPH_PRACTICE_INCOME_FAILURE:
        return {
          loading: false,
          graphDataPracticeIncome: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  